import {PokerComponent} from '@interface/index';
import {getPokerBack, getPokerImage} from '@utils/index';
import useCommon from '@utils/hooks/common';
import classNames from 'classnames';
import {useEffect, useState, useRef} from 'react';
import {
  COMMUNITY_CARD_FLIP_DELAY,
  TRANSITION_DURATION,
  COMMUNITY_CARD_PRE_FLOP_FLIP_DELAY,
  COMMUNITY_CARD_POST_FLOP_FLIP_DELAY,
} from '@constant/game';
import styles from './styles';

const FLIP_DELAY = 300;

const Poker = (props: PokerComponent) => {
  const {
    suit,
    rank,
    className,
    cardClassName,
    state = 'NORMAL',
    isInitiallyFlipped,
    cardSize,
    cardIndex,
    isCommunityCard,
    shouldCardAnimationBePlayed,
    flipDelayFromParent = FLIP_DELAY,
  } = props;
  const {classes, theme} = useCommon({
    withStyles: {styles, hasProps: true, props},
  });

  const isDesktop = theme?.currentStyleFormat?.id === 'desktop';

  const [isFlipped, setIsFlipped] = useState(isInitiallyFlipped);
  const [style, setStyle] = useState<React.CSSProperties>({
    top: 0,
    left: 0,
    transition: `all ${TRANSITION_DURATION / 1000}s ease-in-out`,
    opacity: 0,
  });

  const getFlipDelay = (index: number): number => {
    if (!isCommunityCard) return flipDelayFromParent;
    // for plyers who join room suddenly, maybe buggy
    if (!shouldCardAnimationBePlayed) return flipDelayFromParent;
    if (isCommunityCard) {
      if (index < 3) return COMMUNITY_CARD_PRE_FLOP_FLIP_DELAY;
      return COMMUNITY_CARD_POST_FLOP_FLIP_DELAY;
    }
    return 0;
  };
  const flipTimer = useRef<NodeJS.Timeout>();

  useEffect(() => {
    flipTimer.current = setTimeout(() => {
      setIsFlipped(true);
    }, getFlipDelay(cardIndex));
    return () => {
      clearTimeout(flipTimer.current);
    };
  }, []);

  const getClassNamesOfCard = () => {
    return classNames({[classes.cardImage]: typeof cardClassName === 'undefined'}, cardClassName);
  };

  const getContainerClassName = () => {
    if (state === 'RAISED') {
      return classes.raised;
    }
    if (state === 'DARKEN') {
      return classes.darken;
    }
    return null;
  };

  useEffect(() => {
    if (state === 'RAISED') {
      setStyle({
        ...style,
        // top: 'unset',
        // left: 'unset',
      });
    }
  }, [state]);

  const getLeftValue = (pokerCardIndex: number): number => {
    if (pokerCardIndex === 0) return 100;
    if (pokerCardIndex === 1) return 50;
    if (pokerCardIndex === 2) return 0;
    return 0;
  };
  // console.log('&&& shouldAnimationBePlayed &&&', shouldAnimationBePlayed);
  useEffect(() => {
    if (!isCommunityCard) {
      setStyle({});
    }
    if (!shouldCardAnimationBePlayed) {
      setStyle({});
    }
    // if (!shouldAnimationBePlayed) return;
    if (shouldCardAnimationBePlayed && cardIndex <= 2) {
      // move to table center
      setStyle({
        ...style,
        top: 100,
        left: getLeftValue(cardIndex),
        opacity: 0,
      });
      // move to LHS of the cards container
      setTimeout(() => {
        setStyle({
          ...style,
          top: 0,
          left: `-${cardIndex * 50}px`,
          opacity: 1,
          transitionDelay: '0s',
        });
      }, TRANSITION_DURATION * 2);
      // cards are back to original position
      setTimeout(() => {
        setStyle({
          ...style,
          top: 0,
          left: 0,
          opacity: 1,
        });
      }, TRANSITION_DURATION * 4);
    }

    if (shouldCardAnimationBePlayed && cardIndex > 2) {
      // move cards to table center
      setStyle({top: 100, left: -70});
      // cards are back to original position
      setTimeout(() => {
        setStyle({
          ...style,
          top: 0,
          left: 0,
          opacity: 1,
        });
      }, TRANSITION_DURATION / 2);
    }
  }, []);
  return (
    // inline
    // boxShadow: '#FFD945 0px 0px 15px',
    <article
      style={style}
      className={classNames(classes.cardContainer, className, getContainerClassName())}
    >
      <div className={classNames(classes.goldBorder, {show: state === 'RAISED'})}>
        <div
          className={classNames(classes.innerContainer, {
            flipped: isFlipped,
            [classes.small]: cardSize === 'small',
            [classes.medium]: cardSize === 'medium' || typeof cardSize === 'undefined',
            [classes.large]: cardSize === 'large',
            show: state === 'RAISED',
            // TODO: new win effect
            // !gap between cards and boxShadow coz there is gap between the card and the pic
            // win: state === 'RAISED',
          })}
        >
          <div className={classes.gradientLayer} />
          <img
            src={getPokerImage({suit, rank, isDesktop})}
            alt=""
            className={classNames(getClassNamesOfCard(), classes.frontFace)}
          />
          <img
            src={getPokerBack()}
            alt=""
            className={classNames(getClassNamesOfCard(), classes.backFace)}
          />
        </div>
      </div>
    </article>
  );
};

export default Poker;
